<app-loading-spinner
  *ngIf="isLoading"
  class="spinner-full-page"
/>

<div class="nav-bar">
  <h1>ZippMat Customer Portal</h1>

  <div class="action-buttons">
    <mat-button-toggle-group
      class="switch-toggle"
      [value]="buttonToggleOptions"
      [hideSingleSelectionIndicator]="true"
      (change)="onValChange($event.value)"
    >
      <mat-button-toggle value="orders">Orders</mat-button-toggle>
      <mat-button-toggle value="payments">Payments</mat-button-toggle>
    </mat-button-toggle-group>

    <button
      mat-stroked-button
      class="logout-btn"
      (click)="onLogout()"
    >
      <span class="material-icons"> logout </span>
    </button>
  </div>
</div>

<ng-container *ngIf="!isLoading">
  <div class="customer-info">
    <img
      [src]="customerInfo.logoImageUrl"
      *ngIf="customerInfo.logoImageUrl !== null"
      alt="Customer Logo"
      height="50px"
    />

    <span style="max-width: 80%; margin-left: 12px; text-align: left; font-size: 16px; font-weight: bold">
      {{ customerInfo.name }}
    </span>
  </div>

  <div class="container">
    <!-- <mat-card>
      <mat-card-content>
        <div>
          <b>{{ highlightStatementTiles.totalTransactionAmount }}</b>
          <span> Total Relationship Value</span>
        </div>
        <div>
          <b>{{ highlightStatementTiles.numberOfMonths }}</b>
          <span> Months of Business</span>
        </div>
        <div>
          <b>{{ highlightStatementTiles.numberOfProducts }}+</b>
          <span> Number Of Products</span>
        </div>
        <div>
          <b>{{ highlightStatementTiles.numberOfDeliverySites }}</b>
          <span> Delivery Sites</span>
        </div>
      </mat-card-content>
    </mat-card> -->

    <!-- <div class="aging-report-button">
      <button
        mat-flat-button
        (click)="onAgingReportClick()"
      >
        <b>Repayment Report</b>
      </button>
    </div> -->

    <div
      class="order-container"
      *ngIf="buttonToggleOptions === 'orders'"
    >
      <form
        [formGroup]="searchForm"
        class="search-form"
      >
        <div class="filter-container">
          <app-selection-input
            [control]="$any(searchForm.get('dateRange'))"
            [options]="filteredOptions['dateRange']"
            (selectedOption)="applyOrderFilter()"
          >
          </app-selection-input>

          <app-autocomplete-backend-input
            label="PO Number"
            placeholder="PO Number"
            [control]="$any(searchForm.get('poNumber'))"
            [options]="filteredOptions['poNumber']"
            [noSelection]="true"
            (selectionChanged)="applyOrderFilter()"
            (searchStringChange)="onPoNumberStringChange($event)"
          >
          </app-autocomplete-backend-input>

          <app-autocomplete-backend-input
            label="Project"
            placeholder="Project"
            [control]="$any(searchForm.get('project'))"
            [options]="filteredOptions['project']"
            [noSelection]="true"
            (selectionChanged)="applyOrderFilter()"
            (searchStringChange)="onProjectStringChange($event)"
          >
          </app-autocomplete-backend-input>

          <app-autocomplete-backend-input
            label="Category / Product"
            placeholder="Category / Product"
            [control]="$any(searchForm.get('categoryProduct'))"
            [options]="filteredOptions['categoryProduct']"
            [noSelection]="true"
            (selectionChanged)="applyOrderFilter()"
            (searchStringChange)="onCategoryProductStringChange($event)"
          >
          </app-autocomplete-backend-input>
        </div>
      </form>
      <div class="order-type-options">
        <mat-chip-listbox
          [multiple]="false"
          (change)="setOrderType($event.value)"
          [formControl]="$any(searchForm.get('orderType'))"
        >
          <mat-chip-option
            *ngFor="let option of orderTypeOptions"
            [value]="option.key"
          >
            {{ option.value }}
          </mat-chip-option>
        </mat-chip-listbox>
      </div>
      <div>
        <div
          class="empty-state"
          *ngIf="orderData.length === 0"
        >
          <mat-icon>inventory_2</mat-icon>
          <p>No orders found matching the selected filters</p>
        </div>
        <ng-container *ngFor="let order of orderData">
          <mat-card
            class="order-card"
            (click)="navigateToOrderPage(order.id)"
          >
            <div class="header-row">
              <div>
                <div class="order-id">{{ order.enquiryNum }}</div>
                <div class="order-date">{{ order.date }}</div>
              </div>
            </div>

            <div class="info-block">
              <label>PO Number</label>
              <div class="value">{{ order.poNumber }}</div>
            </div>

            <div class="info-block">
              <label>Items</label>
              <div class="value">{{ order.items }}</div>
            </div>

            <div class="info-block">
              <label>Project</label>
              <div class="value">{{ order.project }}</div>
            </div>

            <mat-divider></mat-divider>

            <div class="quantity-amount">
              <div>
                <label>Quantity</label>
                <div class="value">{{ order.quantity }}</div>
              </div>

              <div class="amount-block">
                <label>Amount</label>
                <div class="value">₹{{ order.quotationAmt }}</div>
              </div>
            </div>
          </mat-card>
        </ng-container>
      </div>
    </div>

    <div *ngIf="buttonToggleOptions === 'payments'">
      <div
        id="highlight-tiles"
        class="grid-display-2"
      >
        <div class="tile">
          Total Outstanding
          <b>₹ {{ agingReport.outstanding }}</b>
        </div>
        <div class="tile">
          Not Due
          <b>₹ {{ agingReport.notDue }}</b>
        </div>
        <div class="tile">
          Total Due
          <b>₹ {{ agingReport.due }}</b>
        </div>
        <div class="tile">
          <button
            mat-button
            (click)="downloadZohoCustomerStatement()"
            [disabled]="downloadZohoCustomerStatementButtonLoading"
          >
            <app-loading-spinner-button
              *ngIf="downloadZohoCustomerStatementButtonLoading"
            ></app-loading-spinner-button>
            <span
              *ngIf="!downloadZohoCustomerStatementButtonLoading"
              class="material-icons"
            >
              download
            </span>
          </button>
          <b>Download Ledger</b>
        </div>
      </div>
      <div class="payment-container">
        <h2 class="title">Outstanding Payments</h2>
        <p class="subtitle">Invoices pending payment</p>
        <div
          *ngIf="invoiceData.length === 0"
          class="empty-state"
        >
          <mat-icon>check_circle</mat-icon>
          <p>No outstanding invoices 🎉</p>
        </div>
        <app-loading-spinner *ngIf="outstandingInvoiceDataLoader" />
        <mat-card
          class="invoice-card"
          *ngFor="let invoice of invoiceData"
        >
          <mat-card-content>
            <div class="header-row">
              <div>
                <div class="invoice-number">{{ invoice?.invoiceNo }}</div>
                <div class="invoice-date">Date: {{ invoice?.invoiceDate }}</div>
              </div>

              <div
                class="due-chip"
                [ngClass]="{ overdue: invoice.daysPastDue > 0, 'not-due': invoice.daysPastDue <= 0 }"
              >
                <mat-icon *ngIf="invoice.daysPastDue > 0">error_outline</mat-icon>
                {{ invoice.daysPastDue > 0 ? invoice.daysPastDue + " days" : "Not Due" }}
              </div>
            </div>

            <mat-divider></mat-divider>

            <div class="details-row">
              <div>
                <label>Due Date</label>
                <div class="value">{{ invoice?.dueDate }}</div>
              </div>

              <div class="amount-block">
                <label>Amount</label>
                <div class="value">₹{{ invoice?.amount }}</div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-paginator
          #paginator
          [pageSize]="outstandingInvoicePageSize"
          [hidePageSize]="true"
          (page)="onChangePage($event)"
          [length]="totalOutstandingInvoicesDataLength"
        />
      </div>
    </div>
  </div>
</ng-container>
